import type { ShelterGetShelterQuery } from '@gql/graphql';
import type {
  CardItemArticleData,
  CardItemShelterData,
  RelatedLinksData,
  SlideshowData,
} from '@presentation/components';

export interface ShelterData {
  name?: string;
  text?: string;
  description?: string | null;
  additionalInfo?: string | null;
  email?: string;
  phoneNumber?: string;
  website?: string | null;
  address?: NonNullable<ShelterGetShelterQuery['findManyDogShelter']>[number]['address'] | null;
  formattedAddress?: string;
  agreement?: string;
  spokenLanguages?: string;
}

export interface ShelterPageData {
  shelterLoading?: boolean;
  shelterData?: ShelterData;
  slideshowData?: SlideshowData;
  articleItems?: CardItemArticleData[];
  articleItemsLoading?: boolean;
  shelterItems?: CardItemShelterData[];
  shelterItemsLoading?: boolean;
  relatedLinks?: RelatedLinksData;
  onSocialShareClick?(): void;
}

export interface ShelterPageProps extends ShelterPageData {}
